import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ScheduledIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor",
    width: size || '12',
    height: size || '12'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1 2h10a1 1 0 0 1 1 1v1H0V3a1 1 0 0 1 1-1zm10 10H1a1 1 0 0 1-1-1V5h12v6a1 1 0 0 1-1 1zM2 7v2h2V7H2zm0-7h1v2H2V0zm7 0h1v2H9V0z",
    fillRule: "evenodd"
  }));
};
ScheduledIcon.displayName = 'ScheduledIcon';
export default ScheduledIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ScheduledIcon.js.map